import axios from 'axios'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    isLoading: false,
    prices: {
      UNLIMITED_MONTHLY: 125000,
      UNLIMITED_YEAR: 1200000,
      UNLIMITED_THREE_YEARS: 3000000
    },
    subscriptionTypes: {
      UNLIMITED_MONTHLY: 'UNLIMITED_MONTHLY',
      UNLIMITED_YEAR: 'UNLIMITED_YEAR',
      UNLIMITED_THREE_YEARS: 'UNLIMITED_THREE_YEARS'
    }
  },
  mutations: {
    'SET_LOADING' (state, value) {
      Vue.set(state, 'isLoading', value)
    },

    'SET_SUBSCRIPTION_MONTHLY_PRICE' (state, price) {
      Vue.set(state.prices, 'UNLIMITED_MONTHLY', Number(price))
    },

    'SET_SUBSCRIPTION_YEAR_PRICE' (state, price) {
      Vue.set(state.prices, 'UNLIMITED_YEAR', Number(price))
    },

    'SET_SUBSCRIPTION_THREE_YEARS_PRICE' (state, price) {
      Vue.set(state.prices, 'UNLIMITED_THREE_YEARS', Number(price))
    }
  },
  getters: {},
  actions: {
    loadSubscriptionPrices ({state, dispatch, commit}) {
      if (Object.keys(state.prices).length < 1 && !state.isLoading) {
        commit('SET_LOADING', true)
        return dispatch('getSubscriptionPrices')
          .then((response) => {
            if (response.length > 0) {
              commit('SET_SUBSCRIPTION_MONTHLY_PRICE', response[0].data.cost)
              commit('SET_SUBSCRIPTION_YEAR_PRICE', response[1].data.cost)
              commit('SET_SUBSCRIPTION_THREE_YEARS_PRICE', response[2].data.cost)
            }
            commit('SET_LOADING', false)
          })
          .catch(() => {
            commit('SET_LOADING', false)
          })
      }
    },

    getSubscriptionPrice ({ rootState }, subscriptionType) {
      return axios.post(
        `${rootState.config.API_URL}/billing/calculate`,
        {
          type: 'subscription',
          value: rootState.billing.subscriptionTypes[subscriptionType]
        },
        {
          headers: {
            Authorization: `Bearer ${rootState.user.token}`,
            'Content-Type': 'application/json'
          }
        }
      )
    },

    getSubscriptionPrices ({ rootState, dispatch }) {
      return Promise.all([
        dispatch('getSubscriptionPrice', rootState.billing.subscriptionTypes.UNLIMITED_MONTHLY),
        dispatch('getSubscriptionPrice', rootState.billing.subscriptionTypes.UNLIMITED_YEAR),
        dispatch('getSubscriptionPrice', rootState.billing.subscriptionTypes.UNLIMITED_THREE_YEARS)
      ])
    },

    sendSubscriptionData ({ rootState, dispatch }, { name, company, address, phone, email, plan }) {
      return axios.post(
        `${rootState.config.API_URL}/billing/order`,
        { name, company, address, phone, email, plan },
        {
          headers: {
            Authorization: `Bearer ${rootState.user.token}`,
            'Content-Type': 'application/json'
          }
        }
      )
    },

    buySubscription ({ rootState }, { token, idempotentKey, subscriptionType }) {
      return axios.post(
        `${rootState.config.API_URL}/billing/submit`,
        {
          type: 'subscription',
          value: subscriptionType,
          token: token,
          transactionKey: idempotentKey
        },
        {
          headers: {
            Authorization: `Bearer ${rootState.user.token}`,
            'Content-Type': 'application/json'
          }
        }
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/billing.js